module.exports = __webpack_public_path__ + "img/desk.81eb96c0.png";